<template>
  <div
    class="relative rounded-md text-sm gap-x-1.5 px-2.5 py-1.5 border border-lightGray-500 shadow-xs text-gray-900 font-light transition-colors duration-200"
    :class="{
      'bg-calmBlue hover:bg-calmBlue-600': active,
      'bg-white hover:bg-calmBlue-300': !active
    }"
    role="checkbox"
    aria-label="Support need filter"
    :aria-checked="active"
    @keydown.space.prevent="chooseCat"
  >
    <input
      :id="`filter-category-${supportNeedCategoryUid}`"
      v-model="selectedCategories"
      tabindex="-1"
      type="checkbox"
      :value="supportNeedCategoryUid"
      class="absolute inset-0 cursor-pointer opacity-0 focus:outline-red-500"
      :aria-checked="active"
    />
    <label :for="`filter-category-${supportNeedCategoryUid}`" class="cursor-pointer flex items-center">
      <UIcon v-if="active" name="mdi:check" class="mr-1" />
      {{ supportNeedCategoryDisplayText }}
      <div>
        <LazyFrontendServiceFilterToggleableToggle
          v-if="toggleable"
          :filter-id="`support-needs:${supportNeedCategoryUid}`"
        />
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  toggleable: Boolean,
  supportNeedCategoryUid: {
    type: String,
    required: true
  },
  supportNeedCategoryDisplayText: {
    type: String,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
})

// Should v-model with filters.supportNeeds from service search store
const selectedCategories = defineModel({
  type: Array as PropType<string[]>
})

const chooseCat = () => {
  console.log('chooseCat')
  if (!selectedCategories.value) selectedCategories.value = []
  const supportNeedCategoryUid = props.supportNeedCategoryUid

  const index = selectedCategories.value.indexOf(supportNeedCategoryUid)
  if (index === -1) {
    selectedCategories.value.push(supportNeedCategoryUid)
  } else {
    selectedCategories.value.splice(index, 1)
  }
}
</script>
